// dependencies
import React from "react";
import { connect } from "react-redux";

// components
import PageTitle from "../../../components/PageTitle";
import Progress from "../../../components/ProgressTimeline";
// config
import Config from "./Config";

// actions
import { changePage, initialize } from "./actions";

// selectors
import { getAppWidth, getUserCompanyName } from "../../../selectors/app";
import { getCurrentPage, getDeactivatedActors } from "./selectors";

import PropTypes from "../../../lib/prop-types";

import CreateWorkflow from "./steps/CreateForm";
// steps
import Finishing from "./steps/Finishing";
import TemplateAssigning from "./steps/TemplateAssigning";
import UserSelection from "./steps/UserSelection";

export class CreateWorkflowsTemplatePage extends React.Component {
	static propTypes = {
		initialize: PropTypes.func.isRequired,
		changePage: PropTypes.func.isRequired,
		appWidth: PropTypes.number.isRequired,
		currentPage: PropTypes.number.isRequired,
		deactivatedActors: PropTypes.bool,
	};

	static defaultProps = {};

	componentDidMount() {
		this.props.initialize();
	}

	handleNextButton = () => {
		const { currentPage, deactivatedActors } = this.props;
		if (currentPage === 2 && deactivatedActors) {
			this.props.changePage(currentPage + 1);
		} else if (currentPage !== 2 || (currentPage === 2 && !deactivatedActors)) {
			this.props.changePage(currentPage + 1);
		}
	};

	handleBackButton = () => {
		const { currentPage } = this.props;
		this.props.changePage(currentPage - 1);
	};

	handleDotClick = (page) => {
		this.props.changePage(page);
	};

	render() {
		const { appWidth, currentPage, deactivatedActors } = this.props;
		const formIsComplete = true;
		let content = "";

		if (currentPage === 0) {
			content = <CreateWorkflow />;
		} else if (currentPage === 1) {
			content = <UserSelection />;
		} else if (currentPage === 2) {
			content = <TemplateAssigning />;
		} else if (currentPage === 3) {
			content = <Finishing />;
		}

		return (
			<>
				<PageTitle
					title={`Launch Workflow${this.props.companyName ? ` - ${this.props.companyName}` : ""} - PerformYard`}
				/>
				<section
					className="page-wrapper"
					style={{
						margin: `0 ${Config.pageWrapperSpacing}px`,
						paddingTop: Config.pageWrapperSpacing,
						paddingBottom: "80px",
					}}
				>
					<section className="mx-auto w-[500px] border-b border-solid border-b-[var(--py-neutral-1)] pb-2.5">
						<Progress
							onClick={this.handleDotClick}
							height={30}
							pageCount={4}
							currentPage={currentPage}
							width={300}
						/>
					</section>

					{content}

					<div
						style={{
							width: appWidth - 20,
							left: 10,
							bottom: ((formIsComplete || currentPage > 0) && currentPage) !== 3 ? 10 : -100,
						}}
						className="fixed bottom-0 left-0 h-[60px] w-full rounded bg-primary-5 transition-all duration-150 ease-out"
					>
						{currentPage !== 0 ? (
							<button
								onClick={this.handleBackButton}
								className="absolute left-2.5 top-3 h-9 w-[100px] cursor-pointer rounded-sm border-0 bg-black/30 px-3 py-2 text-white shadow-none hover:bg-black/40"
							>
								Back
							</button>
						) : (
							""
						)}
						<button
							disabled={currentPage === 2 && deactivatedActors}
							onClick={this.handleNextButton}
							className="absolute right-2.5 top-3 h-9 w-[100px] cursor-pointer rounded-sm border-0 bg-white px-3 py-2 font-medium text-primary-5 shadow-none"
						>
							Next
						</button>
					</div>
				</section>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	appWidth: getAppWidth(state),
	companyName: getUserCompanyName(state),
	currentPage: getCurrentPage(state),
	deactivatedActors: getDeactivatedActors(state),
});

const mapDispatchToProps = (dispatch) => ({
	initialize: () => dispatch(initialize()),
	changePage: (pageNumber) => dispatch(changePage(pageNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateWorkflowsTemplatePage);
